import { DEFAULT_COUNTRY, DEFAULT_TELEPHONE_CODE } from "../shared/types";
import {
  Attorney,
  AttorneyValues,
  PersonType,
  PowerOfAttorneyModel,
} from "./types";
import { defaultAddress } from "../shared/defaults";

// We create new object with function because Formik has some issues with "touched" with objects having nested objects.
export const createDefaultAttorneyData: () => PersonType = () => ({
  nationality: DEFAULT_COUNTRY,
  birthdate: "",
  gender: null,
  firstName: "",
  lastName: "",
  fullStreet: "",
  address: defaultAddress(),
  mobile: {
    code: DEFAULT_TELEPHONE_CODE,
    number: "",
  },
  emailBusiness: "",
  isSameAsAdmin: false,
});

export const defaults: PowerOfAttorneyModel = {
  attorneyType: AttorneyValues.ADMIN as Attorney,
  adminAttorneysData: [{ ...createDefaultAttorneyData(), isSameAsAdmin: true }],
  attorneysData: [{ ...createDefaultAttorneyData(), isSameAsAdmin: false }],
};
